module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_online_reserve_gold-d4a0f01dd6fdeab66e66ba5013ad5853.svg";